<div class="w-100 container-create-map" [class.content-page-create]="!fromVenue && !fromEvent" *ngIf="!loading">
    <div class="d-flex container" [class]="fromVenue?'justify-content-end btns-edit-venue':'justify-content-between'"
        *ngIf="!loadingCanvas && !fromEvent">
        <div class="d-flex align-items-end" *ngIf="!fromVenue">
            <p class="title-map"><i (click)="cancel()" class="fa-light fa-arrow-left" style="margin-right: 10px;"></i>
                {{ idMap ? 'Editar:' : 'Crear mapa'}} </p>
            <p *ngIf="titleMap" class="name-map" (click)="editName()">
                {{titleMap}}
                <i class="fa-light fa-pen" style="font-size: 18px; margin-left: 10px;"></i>
            </p>
        </div>

        <div class="d-flex btns-save-map" *ngIf="allowCreate && !fromEvent && (!fromVenue || (fromVenue && isSuperAdmin))">
            <button class="btn primary-button solid" (click)="saveMap()">Guardar</button>
            <button class="btn cancel-button" (click)="cancel()">Cancelar</button>
        </div>
    </div>
    <div [class.content-design]="!fromVenue && !fromEvent">
        <!-- Spinner overlay -->
        <div *ngIf="isSaving" class="canvas-spinner-overlay">
            <div class="save-spinner"></div>
        </div>

        <div *ngIf="!loading">
            <app-generate-canvas [allowCreate]="allowCreate" [fromCreate]="fromCreate" [fromVenue]="fromVenue" [capacity]="capacity"
                [fromEvent]="fromEvent" [idEvent]="idEvent" [idSpace]="idSpace" [editEvent]="editEvent" [mapSaved]="mapSaved"
                (loadCanvas)="paintCanvas($event)" [titleMap]="titleMap" [blockedSeats]="blockedSeats"
                [selectedSession]="selectedSession" [seatsOrders]="seatsOrders"
                [channelsMap]="channelsMap"></app-generate-canvas>
        </div>

    </div>


</div>